const PROFIT_TIER_INPUT_PATTERN = /^\d*(?:\.\d{0,2})?$/;

export function sanitizeProfitTierInput(value: string): string | null {
  const normalizedValue = value.trim();

  if (normalizedValue === "") {
    return "";
  }

  if (!PROFIT_TIER_INPUT_PATTERN.test(normalizedValue)) {
    return null;
  }

  return normalizedValue;
}
